<div class="chart-container">
  <div *ngIf="widgetData" [id]='widgetData.widget_id + "_dialog"' class="chart-div"></div>
  <div fxLayout="row" fxLayoutAlign="end center">
    <button mat-icon-button (click)="exitFullScreen()"><mat-icon>fullscreen_exit</mat-icon></button>
  </div>
</div>
